import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Link, useNavigate } from "react-router-dom";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import {
  getGuestWishlist,
  saveGuestWishlist,
  getGuestCart,
  saveGuestCart,
} from "../../utils/guestStorage";



export const Wishlist = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [categoryMap, setCategoryMap] = useState({});
  const navigate = useNavigate();

  useEffect(() => {
    fetchCategories();
    fetchWishlist();
  }, []);

  const fetchCategories = async () => {
    try {
      console.log("=== FETCHING CATEGORIES ===");

      const response = await fetch(
        "https://cyberathon.com/multivendor/index.php/Api/Master_controller/list_main_category"
      );

      const result = await response.json();
      console.log("📂 Categories API Response:", result);

      if (result.status === true || result.status === "true") {
        const map = {};
        result.row.forEach((category) => {
          map[category.category_id] = category.category_name;
        });
        setCategoryMap(map);
        console.log("Category Map Created:", map);
      }
    } catch (err) {
      console.error("❌ Category fetch error:", err);
    }
  };

  const fetchWishlist = async () => {
  const userId = localStorage.getItem("user_id");

  // ================= GUEST =================
  if (!userId) {
    const guestWishlist = getGuestWishlist();
    setProducts(guestWishlist);
    setLoading(false);
    return;
  }

  // ================= USER =================
  try {
    setLoading(true);

    const formData = new FormData();
    formData.append("user_id", userId);

    const response = await fetch(
      "https://cyberathon.com/multivendor/index.php/Api/Master_controller/wish_list",
      {
        method: "POST",
        body: formData,
      }
    );

    const result = await response.json();

    if (result.status === true || result.status === "true") {
      setProducts(result.wishlist || []);
    } else {
      setProducts([]);
    }
  } catch (err) {
    console.error("Wishlist fetch error:", err);
    setProducts([]);
  } finally {
    setLoading(false);
  }
};


  const ensurePublicPath = (imagePath) => {
    if (!imagePath) return "/img/placeholder.png";
    if (imagePath.startsWith("http")) return imagePath;
    return `https://cyberathon.com/multivendor/${imagePath.replace(/^\/+/, "")}`;
  };

  const addToCart = async (product) => {
  const userId = localStorage.getItem("user_id");

  // ============ GUEST ============
  if (!userId) {
    const guestCart = getGuestCart();

    const exists = guestCart.find(
      (item) => item.product_id === product.product_id
    );

    if (exists) {
      exists.cart_qty += 1;
    } else {
      guestCart.push({
        product_id: product.product_id,
        name: product.product_name,
        price: product.current_price,
        image: product.multi_image?.[0] || "/img/placeholder.png",
        cart_qty: 1,
        size: "",
        color: "",
      });
    }

    saveGuestCart(guestCart);
    alert("Item added to bag");
    navigate("/bag");
    return;
  }

  // ============ USER ============
  try {
    const formData = new FormData();
    formData.append("user_id", userId);
    formData.append("product_id", product.product_id);
    formData.append("cart_qty", 1);
    formData.append("size", "");
    formData.append("color", "");
    formData.append("current_price", product.current_price);

    await fetch(
      "https://cyberathon.com/multivendor/index.php/Api/Master_controller/add_cart",
      { method: "POST", body: formData }
    );

    navigate("/bag");
  } catch (err) {
    console.error(err);
  }
};


  const removeFromWishlist = async (wishId) => {
  const userId = localStorage.getItem("user_id");

  // ============ GUEST ============
  if (!userId) {
    const updated = getGuestWishlist().filter(
      (item) => item.product_id !== wishId
    );
    saveGuestWishlist(updated);
    setProducts(updated);
    return;
  }

  // ============ USER ============
  try {
    const formData = new FormData();
    formData.append("user_id", userId);
    formData.append("wish_id", wishId);

    const response = await fetch(
      "https://cyberathon.com/multivendor/index.php/Api/Master_controller/delete_wish_list",
      { method: "POST", body: formData }
    );

    const result = await response.json();

    if (result.status === true || result.success === "1") {
      fetchWishlist();
    }
  } catch (err) {
    console.error("Remove wishlist error:", err);
  }
};



  if (loading) {
    return (
      <div className="container bg-white wish-list">
        <div className="text-center py-5">
          <h3>Loading wishlist...</h3>
        </div>
      </div>
    );
  }

  if (products.length === 0) {
    return (
      <div className="container bg-white wish-list">
        <div className="text-center py-5">
          <h3>Your wishlist is empty</h3>
          <p className="text-muted">Start adding products you love!</p>
          <Link to="/" className="btn btn-primary mt-3">
            Continue Shopping
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="container bg-white wish-list">
      <div className="d-flex justify-content-between align-items-center">
        {/* <h3 className="fw-bold p-1 text-center">Wishlist</h3>  */}
        {/* <a href="#" className="text-decoration-none bg-white" style={{color:"#ff7043"}}>
          View All <i className="bi bi-chevron-right bg-white"></i>
        </a> */}
      </div>
      <div className="row justify-content-center">
        {products.map((product) => {
          // Get first image from multi_image array
         const productImage =
  product.multi_image?.length > 0
    ? ensurePublicPath(product.multi_image[0])
    : product.image || "/img/placeholder.png";

          // Calculate discount percentage
          const oldPrice = parseFloat(product.old_price);
          const currentPrice = parseFloat(
  product.current_price || product.price || 0
);

          const discountPercent = oldPrice > 0 
            ? Math.round(((oldPrice - currentPrice) / oldPrice) * 100)
            : 0;

          return (
            <div
              key={product.product_id}
              className="col-lg-3 col-md-4 col-sm-6 col-6 mb-4 d-flex mt-4"
            >
              <div className="card flex-fill h-100 shadow-sm border rounded-3" style={{ position: "relative" }}>
                {/* Cross Button */}
                <button
                 onClick={() => removeFromWishlist(
  localStorage.getItem("user_id")
    ? product.wish_id
    : product.product_id
)}
                  style={{
                    position: "absolute",
                    top: "10px",
                    right: "10px",
                    background: "white",
                    border: "1px solid #ddd",
                    borderRadius: "50%",
                    width: "30px",
                    height: "30px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    cursor: "pointer",
                    zIndex: 10,
                    fontSize: "18px",
                    fontWeight: "bold",
                    color: "#666",
                    boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                    transition: "all 0.2s"
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.background = "#ff3e6c";
                    e.target.style.color = "white";
                    e.target.style.borderColor = "#ff3e6c";
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.background = "white";
                    e.target.style.color = "#666";
                    e.target.style.borderColor = "#ddd";
                  }}
                  title="Remove from wishlist"
                >
                  ×
                </button>
                <img
                  src={productImage}
                  className="card-img-top p-3"
                  alt={product.product_name}
                  style={{ height: "250px", objectFit: "contain", cursor: "pointer" }}
                  onClick={() => navigate(`/product/${product.product_id}`)}
                />
                <div className="card-body">
                  <h6 
                    className="fw-bold mb-1" 
                    style={{ cursor: "pointer" }}
                    onClick={() => navigate(`/product/${product.product_id}`)}
                  >
                    {(product.product_name || product.name || "")
  .split(" ")
  .slice(0, 4)
  .join(" ")}
                  </h6>
                  <p className="text-muted small mb-1">
                    {categoryMap[product.category_id] || "Category"}
                  </p>

                  <div className="wish-prod-rating d-flex d-md-none align-items-center mb-2">
                    <span className="fw-semibold me-1">
                      {product.rating || "4.5"}
                    </span>
                    <span style={{ color: "#f5c518" }}>★</span>
                    <span className="text-dark ms-1 small">
                      | Ratings
                    </span>
                  </div>

                  <p
                    className={`fw-semibold mb-1 ${
                      parseInt(product.stock) > 10
                        ? "text-success"
                        : "text-warning"
                    }`}
                  >
                    {parseInt(product.stock) > 10 ? "In Stock" : "Few Left"}
                  </p>

                  <div className="d-flex align-items-center gap-2">
                    <h6 className="fw-bold mb-0">₹{currentPrice}</h6>
                    {oldPrice > currentPrice && (
                      <>
                        <small className="text-muted text-decoration-line-through">
                          ₹{oldPrice}
                        </small>
                        <small className="text-danger fw-semibold">
                          ({product.discount }% OFF)
                        </small>
                      </>
                    )}
                  </div>
                  <div className="mt-3 text-center">
                    <Link to={`/model/${product.product_id}`}>
                    <button 
                      type="button" 
                      className="Addto-cart"
                    >
                      Add to cart
                    </button>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};